import * as React from 'react';
import SearchView from 'containers/search';
import { pwrDistroReviewFieldsets } from 'containers/search/SearchForm';

export function ReviewSearch(props) {
  return (
    <SearchView
      label="Reviews"
      primaryFieldsets={pwrDistroReviewFieldsets.primaryFieldsets}
      extraFieldsets={pwrDistroReviewFieldsets.extraFieldsets}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/search/PwrDistribution/ReviewSearch.js